import { createSelector } from 'reselect';

const selectBookings = (state: any) => state.bookings;

export const selectBookingsCurrentItem = createSelector([selectBookings], (bookings) => bookings.current);

export const selectBookingsListItems = createSelector([selectBookings], (bookings) => bookings.list);


export const selectBookingsItemById = (itemId: any) =>
    createSelector(selectBookingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBookingsQueryItems = createSelector([selectBookings], (bookings) => bookings.query);

export const selectBookingsCreatedItem = createSelector([selectBookings], (bookings) => bookings.create);

export const selectBookingsUpdatedItem = createSelector([selectBookings], (bookings) => bookings.update);

export const selectBookingsReadItem = createSelector([selectBookings], (bookings) => bookings.read);

export const selectBookingsDeletedItem = createSelector([selectBookings], (bookings) => bookings.delete);

export const selectBookingsSearchedItems = createSelector([selectBookings], (bookings) => bookings.search);

export const selectBookingsItemsCount = createSelector([selectBookings], (bookings) => bookings.count);

export const selectBookingsItemsFilter = createSelector([selectBookings], (bookings) => bookings.filter);